import React from 'react'
import { Redirect } from 'react-router-dom'

export const LiveListenRedirect = () => {
  return <Redirect to="/live-listen" />
}
